<ng-template #triggerButton>
    <button
        type="button"
        class="disclosure-trigger"
        data-sirius-disclosure-trigger
        [id]="triggerId()"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="regionId()"
        (click)="toggle()"
    >
        @if (triggerContent(); as content) {
            <ng-container
                [ngTemplateOutlet]="content"
                [ngTemplateOutletContext]="{ $implicit: expanded(), expanded: expanded() }"
            ></ng-container>
        } @else {
            <span [class]="labelClass()">{{ label() || (labelKey() | translate) }}</span>
        }
        @switch (triggerIcon()) {
            @case ('chevron') {
                <sirius-icon class="disclosure-chevron" name="caret_down" aria-hidden="true"></sirius-icon>
            }
            @case ('plus-minus') {
                <!-- Swapped rather than rotated: the two glyphs read as add/remove, and a rotation
                     between them would land the minus off-centre. -->
                <sirius-icon
                    class="disclosure-plus-minus"
                    [name]="expanded() ? 'minus' : 'plus'"
                    aria-hidden="true"
                ></sirius-icon>
            }
        }
    </button>
</ng-template>

<ng-template #trigger>
    @switch (headingLevel()) {
        @case (2) {
            <h2 class="disclosure-heading" [attr.id]="headingId() || null">
                <ng-container [ngTemplateOutlet]="triggerButton"></ng-container>
            </h2>
        }
        @case (3) {
            <h3 class="disclosure-heading" [attr.id]="headingId() || null">
                <ng-container [ngTemplateOutlet]="triggerButton"></ng-container>
            </h3>
        }
        @case (4) {
            <h4 class="disclosure-heading" [attr.id]="headingId() || null">
                <ng-container [ngTemplateOutlet]="triggerButton"></ng-container>
            </h4>
        }
        @case (5) {
            <h5 class="disclosure-heading" [attr.id]="headingId() || null">
                <ng-container [ngTemplateOutlet]="triggerButton"></ng-container>
            </h5>
        }
        @case (6) {
            <h6 class="disclosure-heading" [attr.id]="headingId() || null">
                <ng-container [ngTemplateOutlet]="triggerButton"></ng-container>
            </h6>
        }
        @default {
            <ng-container [ngTemplateOutlet]="triggerButton"></ng-container>
        }
    }
</ng-template>

@if (showTrigger() && triggerPosition() === 'above') {
    <ng-container [ngTemplateOutlet]="trigger"></ng-container>
}

<div
    class="disclosure-region"
    [id]="regionId()"
    [attr.role]="isRegion() ? 'region' : null"
    [attr.aria-labelledby]="regionLabelledBy()"
    [attr.inert]="isRegion() && !expanded() ? '' : null"
    (focusin)="onRegionFocusIn()"
>
    <div #inner class="disclosure-inner">
        <div class="disclosure-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>

@if (showTrigger() && triggerPosition() === 'below') {
    <ng-container [ngTemplateOutlet]="trigger"></ng-container>
}
